import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import { cards } from 'sections/Resources/data';
import Card from 'sections/Resources/components/Card';
import styles from 'sections/Resources/components/SectionCards/SectionCards.module.scss';

const cn = classNames.bind(styles);

const SectionCards = (): ReactElement => {
  const cardItems = cards.map((card) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <Card.Header>
          <h3 className={cn('card__title')}>{card.title}</h3>
        </Card.Header>
        <Card.Content className={cn('card__description')}>
          <p>{card.description}</p>
        </Card.Content>
        {card.url
          ?
          <Card.Footer className={cn('card__buttons')}>
            <Link className={cn('card__button-learn')} href={card.url as Route}>
              Learn more
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </Card.Footer>
          :
          null
        }
      </Card>
    );
  });

  return (
    <section className={cn('cards')}>
      <div className={cn('container')}>
        <h2 className={cn('cards__heading')}>Subcategories</h2>
        <ul className={cn('cards__list')}>{cardItems}</ul>
      </div>
    </section>
  );
};

export default SectionCards;